var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',[_vm._v(" "+_vm._s(_vm.$t('sidebar.advertiserSettlements'))+" ")]),_c('div',{staticClass:"d-flex flex-column gap-4"},[_c('Filters',{ref:"Filters"}),_c('Invoices',{ref:"Invoices"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }